import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/Service/Common.service';
import { MapRoleFeatureService } from 'src/app/Service/map-role-feature/map-role-feature.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { BusinessGroupModel } from 'src/app/ViewModel/BusinessGroupModel';
import { RoleFeatureMapped } from 'src/app/ViewModel/RoleFeatureMappedModel';
import { RoleFeatureModel } from 'src/app/ViewModel/RoleFeatureModel';
import { RoleFeaturePostModel } from 'src/app/ViewModel/RoleFeaturePostModel';
@Component({
	selector: 'app-map-role-feature',
	templateUrl: './map-role-feature.component.html',
	styleUrls: ['./map-role-feature.component.css']
})
export class MapRoleFeatureComponent implements OnInit {
	/** List of roles */
	public roleList: ReadonlyArray<RoleFeatureModel> = [];
	/** List of Features */
	public featureList: ReadonlyArray<RoleFeatureModel> = [];
	/** User transactional data. Changes done by user, recorded here */
	private userMappedObject = new Map<string, boolean>();
	/** Copy of userMappedObject data, formmated db data */
	private userMappedObjFromDB = new Map<string, boolean>();
	/** Business Group List */
	private businessGroupList: ReadonlyArray<BusinessGroupModel> = [];
	/** Selected Business Group Id */
	private businessGroupId!: number;
	/** Feature Header Checkbox */
	private featureHeader: any = {};
	private roleHeader: any = {};
	public enableFilter = false;
	public enableFullscreen = false;
	private projectId!: number;
	public pageSize = [5, 10, 20, {
		text: 'All',
		value: 'all'
	}];

	constructor(
		private mapRoleFeatureService: MapRoleFeatureService,
		private commonService: CommonService,
		private notificationService: NotificationService,
	) { }

	ngOnInit() {
		this.projectId = this.commonService.getProjectId();
		this.commonService.selectedProjectId.subscribe((data: any) => {
			if (data) {
				this.getBusinessGroups(data);
			}
		});
	}

	/**
	 * Get Business Group list
	 * @param _projectId 
	 */
	getBusinessGroups(_projectId: number) {
		this.mapRoleFeatureService.getBusinessGroups(_projectId).subscribe((data: any) => {
			this.businessGroupList = data.filter((eachData: any) => eachData.is_Active);
		});
	}


	/**
	 * Business group dropdown event handling
	 * @param event 
	 */
	changeBusinessGroup(event: { value: string | number | null; }) {
		if (event.value !== '-2') {
			this.businessGroupId = Number(event.value);
			this.userMappedObjFromDB.clear();
			this.callApis();
		} else {
			this.clearValues();
		}
	}

	/**
	 * Get Roles, Features and Mapped data.
	 * Calling API one after other
	 */
	async callApis() {
		let _dataObj: any = await this.mapRoleFeatureService.getDedAgainstDe('Role', this.businessGroupId, null, null).toPromise();
		let _disObj = _dataObj.filter(
			(thing: { dedId: any; }, i: any, arr: any[]) => arr.findIndex(t => t.dedId === thing.dedId) === i
		);
		this.roleList = _disObj;
		this.featureList = await this.mapRoleFeatureService.getDedAgainstDe('Feature', this.businessGroupId, null, null).toPromise();
		//mapped data needs above two APIs response
		let mappedResponse = await this.mapRoleFeatureService.getRoleFeatureLinkData(this.businessGroupId).toPromise();
		this.formatDataDbToUi(mappedResponse);
	}

	/** 
	 * Set Feature Header Checkbox Status. 
	 * Call after API data received and
	 * Call after every row data checkbox value changes
	 */
	setFeatureHeader(featureId?: number) {
		if (!featureId) {
			this.featureList.forEach(feature => {
				this.featureHeader[feature.dedId] = this.roleList.every((role) => this.userMappedObjFromDB.get(role.dedId + '_' + feature.dedId));
			});
		} else {
			this.featureHeader[featureId] = this.roleList.every((role) => !!this.userMappedObject.get(role.dedId + '_' + featureId));
		}
	}

	setRoleHeader(roleId?: number) {
		if (!roleId) {
			this.roleList.forEach(role => {
				this.roleHeader[role.dedId] = this.featureList.every((feature) => this.userMappedObjFromDB.get(role.dedId + '_' + feature.dedId));
			})
		}
		else {
			this.roleHeader[roleId] = this.featureList.every((feature) => !!this.userMappedObject.get(roleId + '_' + feature.dedId));
		}
	}

	/**
	 * Data row Checkbox event trigger
	 * @param isChecked Checked event status
	 * @param role 
	 * @param feature 
	 */
	mapRoleFeature(isChecked: boolean, roleId: number, featureId: number) {
		let key: string = roleId + '_' + featureId;
		if (this.userMappedObject.has(key)) {
			this.userMappedObject.delete(key);
		} else {
			this.userMappedObject.set(key, isChecked);
		}
		this.setFeatureHeader(featureId);
		this.setRoleHeader(roleId);
	}

	/**
	 * Header checkbox event
	 * @param isChecked Checked event status
	 * @param featureId 
	 */
	checkAllRoles(isChecked: boolean, featureId: number) {
		this.roleList.forEach(eachRole => {
			this.userMappedObject.set(eachRole.dedId + '_' + featureId, isChecked);
			this.userMappedObjFromDB.set(eachRole.dedId + '_' + featureId, isChecked); // update in UI variable also
		});
		this.featureHeader[featureId] = isChecked;
	}

	checkAllFeatures(isChecked: boolean, roleId: number) {
		this.featureList.forEach(eachFeat => {
			this.userMappedObject.set(roleId + '_' + eachFeat.dedId, isChecked);
			this.userMappedObjFromDB.set(roleId + '_' + eachFeat.dedId, isChecked);
		})

	}

	/**
	 * Format UI Data (Object) to DB Data (Array). Done before API call
	 */
	formatDataUiToDb() {
		let output: RoleFeatureMapped[] = [];
		let splitData = [];
		this.userMappedObject.forEach((isCheck, key) => {
			splitData = key.split('_');
			output.push(this.convertData(Number(splitData[0]), Number(splitData[1]), isCheck));
		});
		return output;
	}

	/**
	 * Format DB Data (Array) to UI Data (Object)
	 */
	formatDataDbToUi(arrData: RoleFeatureMapped[]) {
		arrData.forEach(eachData => {
			this.userMappedObjFromDB.set(eachData.roleId + '_' + eachData.featureId, eachData.isCheck);
		});
		this.setFeatureHeader();
		this.setRoleHeader();
	}

	/**
	 * Save changes. API call
	 */
	submitMapped() {
		// no data in kendo
		if (!this.roleList.length) {
			return;
		}

		let roleFeaturesMapping = this.formatDataUiToDb();

		if (!roleFeaturesMapping.length) {
			this.notificationService.showToast("No new changes done", "Warning");
			return;
		}

		let reqData: RoleFeaturePostModel = {
			roleFeaturesMapping,
			createdBy: this.commonService.getLoggedInUserId(),
			projectId: this.commonService.getProjectId(),
			groupId: this.businessGroupId,
		}
		this.mapRoleFeatureService.postRoleFeature(reqData).subscribe((data: any) => {
			this.notificationService.handleResponse(data);
			this.userMappedObject.clear();
		});
	}

	/**
	 * Returns Params as Object
	 * @param roleId 
	 * @param featureId
	 * @param isCheck 
	 */
	convertData = (roleId: number, featureId: number, isCheck: boolean) => ({ roleId, featureId, isCheck })

	/**
	 * Check whether the role and feature mapped or not 
	 * @param roleId 
	 * @param featureId 
	 */
	isChecked = (roleId: number, featureId: number): boolean => !!this.userMappedObjFromDB.get(roleId + '_' + featureId);

	clearValues() {
		this.roleList = [];
		this.featureList = [];
		this.userMappedObject.clear();
		this.userMappedObjFromDB.clear();
	}

	checkGridHeight() {
		if (this.roleList.length > 0)
			return 540;
		else
			return 182;
	}

	toggleFilter() {
		this.enableFilter = !this.enableFilter;
	}

	toggleFullscreen() {
		this.enableFullscreen = !this.enableFullscreen;
	}
}
